import { ShortMsxMpv } from '../../types/ShortMsxMpv'
import { ProductTileModel } from '../productTileCollection/productTileCollection'

/**
 * Builds ProductTileModel from MPV data
 */
export class MpvTileBuilder {
  /**
   * Creates a tile model from server-side MPV data
   */
  static buildFromMpv(mpvId: string, mpvData: ShortMsxMpv | undefined): ProductTileModel {
    const tile: ProductTileModel = {
      mpvId,
      showPrice: true
    }

    if (mpvData?.coreProductId) {
      tile.productId = mpvData.coreProductId
    }

    tile.isOutOfStock = mpvData?.productOutOfStock ?? false

    if (mpvData?.colorInformation) {
      tile.colorInformation = mpvData.colorInformation
    }

    if (mpvData?.version) {
      tile.version = mpvData.version
    }

    return tile
  }
}
